import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { toObservable } from '@angular/core/rxjs-interop'
import { filter, first, map } from 'rxjs'
import { AppStore } from '../app.store'
import { RoleType } from 'src/app/shared/role-types'

export const roleGuard = (role: RoleType): CanActivateFn => {
    return () => {
        const appStore = inject(AppStore)
        const router = inject(Router)

        const checkRole = () => {
            const hasRole = appStore.roles().includes(role)

            if (!hasRole) {
                router.navigateByUrl('/forbidden')
            }

            return hasRole
        }

        if (appStore.meLoaded()) {
            return checkRole()
        }

        return toObservable(appStore.meLoaded).pipe(
            filter(Boolean),
            first(),
            map(() => checkRole())
        )
    }
}
